import { ArrowLeft, ArrowRight, Eye, EyeOff, Check, Info } from 'lucide-react';
import { useState } from 'react';
import './styles/PlatformConfiguration.css';

interface Props {
  nextStep: () => void;
  previousStep: () => void;
}

const PortalActivation = ({ nextStep, previousStep }: Props) => {
  const [activePortal, setActivePortal] = useState(true);
  const [passivePortal, setPassivePortal] = useState(true);

  return (
    <div className="organization-wrapper">
      {/* Header */}
      <div className="branding-header">
        <h2 className="branding-title">Portal Activation</h2>
        <p className="branding-subtitle">Configure active and passive portal access</p>
      </div>

      {/* Description */}
      <p className="portal-description">
        Choose which portals to activate. This affects role setup, user access, and passive task assignment behavior.
      </p>

      {/* Portal Options */}
      <div className="portal-options-list">
        {/* Active Portal */}
        <div
          className={`portal-option-card ${activePortal ? 'portal-option-selected' : ''}`}
          onClick={() => setActivePortal((prev) => !prev)}
        >
          <div className="portal-option-icon">
            <Eye size={16} />
          </div>

          <div className="portal-option-text">
            <p className="portal-option-title">Active Portal</p>
            <p className="portal-option-desc">
              Full management interface — for admins, managers, and active users who manage records, run assessments, and approve workflows.
            </p>
          </div>

          <div className={`portal-option-check ${activePortal ? 'portal-option-check-active' : ''}`}>
            {activePortal && <Check size={14} strokeWidth={3} color="#fff" />}
          </div>
        </div>

        {/* Passive Portal */}
        <div
          className={`portal-option-card ${passivePortal ? 'portal-option-selected' : ''}`}
          onClick={() => setPassivePortal((prev) => !prev)}
        >
          <div className="portal-option-icon">
            <EyeOff size={16} />
          </div>

          <div className="portal-option-text">
            <p className="portal-option-title">Passive Portal</p>
            <p className="portal-option-desc">
              Lightweight interface — for passive users who only see tasks assigned to them, such as policy acknowledgements and action
              items.
            </p>
          </div>

          <div className={`portal-option-check ${passivePortal ? 'portal-option-check-active' : ''}`}>
            {passivePortal && <Check size={14} strokeWidth={3} color="#fff" />}
          </div>
        </div>
      </div>

      {/* Info Banner */}
      <div className="portal-info-banner">
        <Info size={16} className="portal-info-icon" />
        <p className="portal-info-text">Both portals can be active at the same time. Most organizations enable both.</p>
      </div>

      <div className="organization-divider" />

      {/* Footer */}
      <div className="organization-footer">
        <button onClick={previousStep} className="organization-back-btn">
          <ArrowLeft size={18} />
          Back
        </button>

        <div className="organization-footer-right">
          <button onClick={nextStep} className="organization-next-btn">
            Next
            <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PortalActivation;
